import BalancesIcon from '../resources/newIcons/Balances.svg';
import MyCodesIcon from '../resources/newIcons/MyCodes.svg';
import SubmitTicketIcon from '../resources/newIcons/SubmitTicket.svg';
import ClientListIcon from '../resources/newIcons/ClientList.svg';
import GuidanceToolIcon from '../resources/newIcons/GuidanceTool.svg';
import GeneralDetailsIcon from '../resources/newIcons/GeneralDetails.svg';
import ClientList2Icon from '../resources/newIcons/ClientList2.svg';
import AdvisorsIcon from '../resources/newIcons/Advisors.svg';
import HouseManagementIcon from '../resources/newIcons/HouseManagement.svg';
import BookAnalysisIcon from '../resources/newIcons/BookAnalysis.svg';
import ReportsIcon from '../resources/newIcons/Reports.svg';
import MDDSIcon from '../resources/newIcons/MDDs.svg';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

import { hasAccess, Roles } from '../helpers/roles';

// if items need images/icons in the future, we can add an image property to the items SideNav will check for the image property and render it if it exists, otherwise it will render the icon property. The icon property is a MUI icon component, while the image property is a path to an image file.

const MENU_CONFIG = [
  {
    title: 'Portfolio Overview',
    link: '/balances',
    icon: AccountBalanceWalletOutlinedIcon,
    roles: [Roles.EndClient]
  },

  {
    title: 'My Clients',
    link: '/my-clients',
    icon: PeopleAltOutlinedIcon,
    roles: [Roles.WealthManager],

    items: [
      {
        text: 'My Clients',
        secondaryText: 'View your client records',
        link: '/advisor/clients'
      },
      {
        text: 'My Codes',
        secondaryText: 'View your advisor codes across MANCO',
        link: '/advisor/codes'
      },
      {
        text: 'Support',
        secondaryText: 'Submit an error or recommendation to our support team.',
        link: '/advisor/submitTicket'
      }
    ]
  },

  {
    title: 'Client Services',
    link: '/client-services',
    icon: SupportAgentOutlinedIcon,
    roles: [Roles.ClientServices],

    items: [
      {
        text: 'Client List',
        secondaryText: 'View your client records',
        link: '/admin/clients'
      },
      {
        text: 'Guidance Tool',
        secondaryText: 'Help your client find the correct investment',
        link: '/admin/fundfilter'
      }
    ]
  },

  {
    title: 'My Practice',
    link: '/my-practice',
    icon: BusinessCenterOutlinedIcon,
    roles: [Roles.Management],

    items: [
      {
        text: 'General Details',
        secondaryText: 'View and manage practice information and settings',
        link: '/general-details'
      },
      {
        text: 'Client List',
        secondaryText: 'View your client records',
        link: '/practice/clients'
      },
      {
        text: 'Advisors',
        secondaryText: 'View and manage practice advisor list',
        link: '/my-practice/advisors'
      },
      {
        text: 'House Management',
        secondaryText: 'View Advisor and MANCO Codes',
        link: '/my-practice/house-management'
      },
      {
        text: 'Book Analysis',
        secondaryText: 'View book totals across MANCO',
        link: '/my-practice/provider-book-analysis'
      }
    ]
  },

  {
    title: 'System Admin',
    link: '/system-admin',
    icon: AdminPanelSettingsOutlinedIcon,
    roles: [Roles.Support],

    items: [
      {
        text: 'Reports',
        secondaryText: 'Download data tracking reporting',
        link: '/reports'
      },
      {
        text: 'MDDs',
        secondaryText: 'Access and edit upload links',
        link: '/mdds'
      }
    ]
  }
];

export const generateNavItems = (user) => {
  const userRole = user?.role ?? user?.userRole ?? user?.roles?.[0] ?? 0;

  return getMenuByRole(userRole);
};

export const getMenuByRole = (userRole) => {
  const numericRole = Number(userRole) || 0;

  return MENU_CONFIG.filter((item) => {
    if (item.roles?.includes('ALL')) {
      return true;
    }

    return item.roles?.some((role) => hasAccess(numericRole, Number(role)));
  });
};

export default MENU_CONFIG;
